<template>
  <div class="fs-14 lh-24 fw-400">{{alertMessage}}</div>
  <template v-if="(message !== 'Sold out') && !isEmpty(tripID)">
    <ChatButton v-if="dataExpired?.payment_type" btnClass='button-blue mt-30 fw-700 py-12 px-20 br-8 lh-14 fs-14' type='enquiry-2w' :enquiryID='enquiryID' :tripID='tripID' @chatOpen='chatExpiredOpen'>Chat with our Travel Concierge</ChatButton>
    <ChatButton v-else-if="!isEmpty(expertID)" btnClass='button-blue mt-30 fw-700 py-12 px-20 br-8 lh-14 fs-14' type='enquiry-3w' @chatOpen='chatExpiredOpen' :expertID='expertID' :enquiryID='enquiryID' :tripID='tripID'>Chat with {{ designer }}</ChatButton>
  </template>
</template>

<script>

import ChatButton from '../chat/ChatButton'
import { computed } from 'vue'
import { isEmpty } from '~/helper'

export default {
  name: 'ModalTripExpired',
  components: { ChatButton },
  emits: ['handleExpiredModal'],
  props: {
    designer: { type: String, default: ''},
    expertID: { type: Number, default: 0 },
    tripID: { type: Number, default: 0 },
    enquiryID: { type: Number, default: 0 },
    message: { type: String, default: ''},
    dataExpired: { type: Object, default: () => {}},
  },
  setup(props, { emit }) {
    const chatExpiredOpen = () => {
      emit('handleExpiredModal')
    }

    const alertMessage = computed(() => {
      const expired = `The price quote for this trip has expired. To book this trip, contact ${props.designer} to validate the current price of this trip. Please note, due to availability, pricing and inclusions may change.`
      return props.message ? props.message : expired
    })

    return {chatExpiredOpen, alertMessage, isEmpty}
  }
}
</script>

<style scoped>

</style>
